export default {
    slogan: "Trade. Anytime Anywhere",
    download_item_name: "Pionex",
    download_item_desc: "Download the latest version on TestFlight",
    download_item_question: "Have problem when installing?",
    download_item_click_tip: "Tap to get methods",
    download_drawer_title: "FAQ",
    download_drawer_tip1: "My TestFlight can not enter App Store connect?",
    download_drawer_tip2: "Need to input a code?",
    download_drawer_invite_code_issue: "Go back to the download page and tap the download button again. If it still needs a code, you can try switching to another network.",
    download_drawer_connect_issue: "You can switch to the network which can access international network and open TestFlight again. Or you can search Pionex on AppStore using a non-Chinese Apple ID.",
    download_drawer_button_acquire_id: "Get Apple ID and tutorial",
    download_drawer_button_human_service: "Not solved? Contact customer service",
    download_drawer_button_human_service_title: "Customer service",
    download_drawer_button_human_service_desc: "Use Wechat to scan QR code to add customer service",
    download_tutor_click_hint: "Tap this icon at the top right corner",
    download_tutor_open_safari_hint: "Choose “Open with Safari”",
    download_tutor_open_browser_hint: "Choose “Open with a browser”",
    download_tutor_pionex_desc1: "Automated",
    download_tutor_pionex_desc2: "Crypto TradingBot",
    download_android_item_desc: "Download apk file",
    download_tutor_bottom_slogan: "World's 1st exchange with in-built trading bots",

    download_button_text: "Download",
    homepage_downloadapp_ios: "iOS",
    homepage_downloadapp_android: "Android",
    homepage_downloadapp_title: "Trade Anytime, Anywhere",
    down_load_gp_version: "Google Play version",
    down_load_gp_version_desc: "Download from Google Play",
    down_load_apk_version: "APK version",
    down_load_apk_version_desc: "Download using apk file",
    down_load_app_store_version: "AppStore version",
    down_load_app_store_version_desc: "Download from AppStore",
    down_load_testflight_version: "TestFlight version",
    down_load_testflight_version_desc: "Download the latest version from TestFlight to try the new functions",
    down_from: "Download from",
    down_apk: "Download APK",
    scan_qr_download: "Scan QR code to download",
    appstore_url: "https://apps.apple.com/us/app/pionex/id1485348891",
    gp_url: "https://play.google.com/store/apps/details?id=com.pionex.client&referrer=utm_source%3Dofficialweb",
    testflight_url: "https://testflight.apple.com/join/61qN730h",
};
